import { render, staticRenderFns } from "./OrderPrice.vue?vue&type=template&id=37c2af21&scoped=true"
import script from "./OrderPrice.vue?vue&type=script&lang=js"
export * from "./OrderPrice.vue?vue&type=script&lang=js"
import style0 from "./OrderPrice.vue?vue&type=style&index=0&id=37c2af21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c2af21",
  null
  
)

export default component.exports